import {useEffect} from "react"
import axios from "axios"
import {API_ECP_PROJECTS} from "../../constants/apiUrls"
import ProjectsModal from "../../sections/projects-modal/ProjectsModal"
import ProjectsTabs from "../../sections/projects-tabs/ProjectsTabs"
import EcpProjectsHeader from "../../sections/ecp-projects-header/EcpProjectsHeader"
import EcpProjectsContent from "../../sections/ecp-projects-content/EcpProjectsContent"
import EcpProjectsFooter from "../../sections/ecp-projects-footer/EcpProjectsFooter"
import ConfirmationModal from "../../components/confirmation-modal/ConfirmationModal"
import {useTranslation} from "react-i18next"
import {toast} from "react-toastify"
import {useNavigate} from "react-router-dom"
import RequireEcpLicence from "../../tools/RequireEcpLicence"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import {useEcpProjectsContext} from "../../reactContext/contextCustomHooks/useEcpProjectsContext"
import useEcpProjects from "../../swrCustomHooks/useEcpProjects"
import LoadingComponent from "../../components/loading-component/LoadingComponent"

export default function EcpProjects() {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {teamContext} = useTeamContext()
    const {ecpProjectsContext} = useEcpProjectsContext()
    const {ecpProjects, mutateEcpProjects, isLoadingEcpProjects, isErrorEcpProjects} = useEcpProjects(ecpProjectsContext.tab, ecpProjectsContext.page)
    let navigate = useNavigate()
    const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}

    const deleteEcpProject = (value) => {
        return new Promise((resolve, reject) => {
            if (value) {
                axios.delete(`${API_ECP_PROJECTS}/${ecpProjectsContext.isConfirmationModal.id}`, headersRequest)
                .then(() => {
                    mutateEcpProjects()
                    toast.success(t("Project deleted"))
                    resolve()
                })
                .catch((error) => {
                    console.error(`DELETE ${API_ECP_PROJECTS}/${ecpProjectsContext.isConfirmationModal.id}: `, error)
                    toast.error(t("An error has occurred"))
                    reject()
                })
            } else {
                resolve()
            }
        })
    }

    const restoreEcpProject = (value) => {
        return new Promise((resolve, reject) => {
            if (value) {
                axios.put(`${API_ECP_PROJECTS}/${ecpProjectsContext.isConfirmationModal.id}/restore`, {}, headersRequest)
                .then(() => {
                    mutateEcpProjects()
                    toast.success(t("Project restaured"))
                    resolve()
                })
                .catch((error) => {
                    console.error(`PUT ${API_ECP_PROJECTS}/${ecpProjectsContext.isConfirmationModal.id}/restore: `, error)
                    toast.error(t("An error has occurred"))
                    reject()
                })
            } else {
                resolve()
            }
        })
    }

    useEffect(() => {
        sessionContext.role === "admin" && navigate("/neurowide-dashboard")
    }, [])

    if (isErrorEcpProjects || isLoadingEcpProjects || ecpProjects?.message) return <LoadingComponent/>
    return (
        <>
        <RequireEcpLicence types={teamContext.licenceTypes} redirect={true}>
            <div className="VIEW ECP-PROJECTS">
                {ecpProjectsContext.isConfirmationModal.modal && <ConfirmationModal type={"ecp-projects"} deleteEcpProject={deleteEcpProject} restoreEcpProject={restoreEcpProject}/>}
                {ecpProjectsContext.isModal && <ProjectsModal type={"ecp"} mutateEcpProjects={mutateEcpProjects}/>}
                <ProjectsTabs type={"ecp"}/>
                <span className="line-w-80"></span>
                <EcpProjectsHeader/>
                <EcpProjectsContent projects={ecpProjects}/>
                <span className="line-w-80"></span>
                <EcpProjectsFooter/>
            </div>
        </RequireEcpLicence>
        </>
    )
}